import { fromDate, getLocalTimeZone } from "@internationalized/date";
import { TrainInformationDetailedResponse } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/responseSchema";
import { countryCodeSchema } from "features/VehicleSidebar/VehicleList/TrainList/types";
import { z } from "zod";

export const productionDeviationStateSchema = z.enum(["OPEN", "CLOSED"]);
export type ProductionDeviationState = z.infer<
  typeof productionDeviationStateSchema
>;

export const trainWithStateSchema = z.object({
  trainId: z.string(),
  state: productionDeviationStateSchema,
});

export const trainsByDateSchema = z.object({
  date: z.coerce.date(),
  trains: trainWithStateSchema.array().min(1),
});

export const productionDeviationSchema = z.object({
  reference: z.string(),
  countryCode: countryCodeSchema,
  trainIds: z.string().array().min(1),
  fromDate: z.coerce
    .date()
    .transform((time) => fromDate(time, getLocalTimeZone())),
  toDate: z.coerce
    .date()
    .transform((time) => fromDate(time, getLocalTimeZone())),
  eventType: z.string(),
  reasonType: z.string(),
  eventCount: z.number(),
  trainsByDate: trainsByDateSchema.array(),
  state: productionDeviationStateSchema,
  message: z.string().nullish(),
  updatedAt: z.coerce
    .date()
    .transform((time) => fromDate(time, getLocalTimeZone())),
});

export type ProductionDeviationResponse = z.infer<
  typeof productionDeviationSchema
>;

export const productionDeviationDetailedSchema = productionDeviationSchema.and(
  z.object({
    trainEvents: z.custom<TrainInformationDetailedResponse>().array(),
  }),
);

export type ProductionDeviationDetailedResponse = z.infer<
  typeof productionDeviationDetailedSchema
>;

export const productionDeviationIdsSchema = z.string().array();
